import React, {Component} from 'react';
import axios from 'axios';
import {Button, Checkbox, Dropdown, Grid, Header, Image, Responsive, Segment} from "semantic-ui-react";

export default class Login extends Component {

    state = {
        auth: "",
        auths: [],
        remember: false
    };

    constructor(props) {
        super(props);
    }

    handleChange = (e, { name, value }) => {
        this.setState({auth: value});
    };

    handleContinue = () => {
        window.location = "/auth?connector=" + this.state.auth + "&remember=" + this.state.remember;
    };

    handleRemember = (e, { checked }) => {
        this.setState({remember: checked});
    };

    componentDidMount() {
        axios.get("/api/auths").then(res => {
            if (res.status === 200 && res) {
                let data = [];
                let cnt = 0;
                Object.keys(res.data).forEach(k => {
                    data.push({
                        key: cnt,
                        value: k,
                        text: res.data[k]
                    });
                    cnt++;
                });
                this.setState({auths: data})
            } else {
                alert("There was a problem getting login methods. Please try again later");
            }
        }).catch(err => {
            alert("There was a problem getting login methods. Please try again later");
            console.log(err)
        });
    }

    render() {

        const { auths, remember, auth } = this.state;

        return (
            <div>
                <Responsive minWidth={551}>
                    <Grid verticalAlign='middle' columns={2} centered>
                        <Grid.Column>
                            <LoginPane auths={auths} disabled={!auth} handleChange={this.handleChange} handleContinue={this.handleContinue} />
                        </Grid.Column>
                    </Grid>
                </Responsive>
                <Responsive maxWidth={550}>
                    <Grid verticalAlign='middle' columns={1} centered padded>
                        <Grid.Column  width={16} only={'mobile'}>
                            <LoginPane auths={auths} disabled={!auth} handleChange={this.handleChange} handleContinue={this.handleContinue} />
                        </Grid.Column>
                    </Grid>
                </Responsive>
            </div>
        )

    }

}

const LoginPane = ({auths, disabled, handleChange, handleContinue}) => (
    <Segment raised padded className={'login-pane'}>
        <Image src={'/img/favicon.png'} size={'small'} centered />
        <Header as='h4' icon textAlign='center'>
            <Header.Content>
                Please select your login method below.
            </Header.Content>
        </Header>
        <div className={'login-pane-action'}>
            <Dropdown placeholder='Select Financial Institute'
                      fluid search selection
                      options={auths}
                      onChange={handleChange}
                      data-it="fi-dropdown"
                      native={true} />
            {/*<Checkbox*/}
            {/*    label='Remember my decision'*/}
            {/*    checked={remember}*/}
            {/*    onChange={this.handleRemember} />*/}
            <Button onClick={handleContinue} disabled={disabled}>Continue</Button>
        </div>
    </Segment>
);
